import { Div, Tag } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import React from 'react'

import {
  CLP_AS_PLAYBOOK_RELEASE_TIME,
  CLP_PLAYBOOK_TYPE,
  LANDING_PAGE_PLAYBOOK_REPORT_TYPES,
  REPORT_TYPE_TO_TABLE_NAME,
} from 'constants/types'
import { DEFAULT_WORKSPACE } from 'constants/workspaces'
import { formatTime } from 'utils/moment'

const generateSelectOptions = (offset, max) => {
  const list = []
  for (let i = 0; i < max; i++) {
    const opt = i + offset
    list[i] = { label: String(opt), value: opt }
  }
  return list
}

const rowFormatter = ({
  offset = 0,
  onChange,
  orgUsers,
  playbook,
  playbookType,
  totalPlaybooks,
  allWorkspaces,
  showWorkspaceColumn,
}) => {
  const getPrioritySelect = () => {
    const handleChange = (option) => onChange(option, playbook)
    const priorityList = generateSelectOptions(offset + 1, totalPlaybooks)

    return (
      <Select
        onChange={handleChange}
        options={priorityList}
        value={{ label: String(playbook.priority), value: playbook.priority }}
      />
    )
  }

  const getPlaybookName = () => {
    return (
      <Div className="playbooks-table-cell--name__tr">
        <Div>
          <Div className="playbooks-table-cell--name__tr--name">
            {playbook.name}
          </Div>
          <Div className="playbooks-table-cell--name__tr--id">
            {playbook.id}
          </Div>
        </Div>
      </Div>
    )
  }

  const getPlaybookStatus = () => {
    if (!['ENABLED', 'DISABLED'].includes(playbook.status)) {
      return null
    }
    return <Tag statusIsOn={playbook.status === 'ENABLED'} type="status" />
  }

  const getPlaybookType = () => {
    const hasCLPTag =
      playbook.createdAt > CLP_AS_PLAYBOOK_RELEASE_TIME &&
      LANDING_PAGE_PLAYBOOK_REPORT_TYPES.includes(playbook.reportType)

    const type = hasCLPTag
      ? CLP_PLAYBOOK_TYPE
      : REPORT_TYPE_TO_TABLE_NAME[playbook.reportType]

    return <Div className="playbooks-table__report-type-cell">{type}</Div>
  }

  const getLastUpdated = () => {
    return (
      <Div className="playbooks-table__scheduled-for-cell">
        {formatTime(playbook.updatedAt, 'MM/DD/YY')}
      </Div>
    )
  }

  const getUpdatedAuthor = () => {
    const user = orgUsers[playbook.updatedAuthorId] || {}
    return (
      <Div className="playbooks-table__updated-at-cell">
        {user.name || user.email || 'teammate'}
      </Div>
    )
  }

  const Misc = () => {
    if (playbookType === 'OUTBOUND') {
      return (
        <Div className="playbooks-table__misc">
          Outbound playbooks are always highest priority
        </Div>
      )
    }

    if (playbookType === 'ABM') {
      return (
        <Div className="playbooks-table__misc">
          ABM playbooks are always prioritized above normal playbooks.
        </Div>
      )
    }

    return null
  }

  const maybeWorkspaceNameCell = ({ playbook }) => {
    if (showWorkspaceColumn) {
      return [
        {
          className: 'playbooks-prioritized-table-cell--workspace',
          content: (
            <Div>
              {allWorkspaces[playbook.workspaceId]?.name ??
                DEFAULT_WORKSPACE.name}
            </Div>
          ),
        },
      ]
    } else {
      return []
    }
  }

  return [
    {
      className: 'playbooks-prioritized-table-cell--priority',
      content: getPrioritySelect(),
    },
    {
      className: 'playbooks-prioritized-table-cell--name',
      content: getPlaybookName(),
    },
    ...maybeWorkspaceNameCell({ playbook }),
    {
      className: 'playbooks-prioritized-table-cell--status',
      content: getPlaybookStatus(),
    },
    {
      className: 'playbooks-prioritized-table-cell--type',
      content: getPlaybookType(),
    },
    {
      className: 'playbooks-prioritized-table-cell--updated-at',
      content: getLastUpdated(),
    },
    {
      className: 'playbooks-prioritized-table-cell--authored-by',
      content: getUpdatedAuthor(),
    },
    { className: 'playbooks-prioritized-table-cell--misc', content: Misc() },
  ]
}

export default rowFormatter
